export interface Drama {
  id: number;
  name: string;
  rating: number;
  region: string;
  year: number;
  genre: string;
  image: string;
  description: string;
  episodes: number;
}

export const dramas: Drama[] = [
  {
    id: 1,
    name: '长风渡',
    rating: 8.5,
    region: '国产',
    year: 2026,
    genre: '古装',
    episodes: 40,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20costume%20drama%20poster%20with%20beautiful%20couple%20in%20flowing%20silk%20robes%2C%20soft%20pastel%20pink%20and%20golden%20color%20palette%2C%20cherry%20blossom%20petals%2C%20minimalist%20poster%20design%2C%20clean%20background%2C%20cinematic%20portrait%20composition%2C%20warm%20romantic%20atmosphere&width=480&height=640&seq=drama-poster-01&orientation=portrait',
    description: '讲述了徉州城布商之女柳玉茹与当地著名纨绔顾九思阴差阳错结为夫妻，性格迥异的两人从相互抵触到相互扶持、相互治愈的暖心故事。在乱世之中，两人携手共度难关，从市井小民成长为能够独当一面的栋梁之才，谱写了一曲动人的爱情与成长之歌。',
  },
  {
    id: 2,
    name: '漫长的季节',
    rating: 9.4,
    region: '国产',
    year: 2025,
    genre: '悬疑',
    episodes: 12,
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20mystery%20crime%20drama%20poster%20with%20rainy%20industrial%20town%20street%20scene%2C%20lone%20silhouette%20walking%20on%20wet%20train%20tracks%2C%20overcast%20sky%2C%20autumn%20golden%20leaves%2C%20film%20noir%20aesthetic%2C%20cool%20teal%20and%20warm%20amber%20color%20grading%2C%20cinematic%20poster%20composition&width=480&height=640&seq=drama-poster-02&orientation=portrait',
    description: '一座东北工业小城，一包身份未明的碎尸包裹，一座横跨二十年的谜团。出租车司机王响、下岗刑警马德胜与年轻侦察员合力追查真相，三条时间线交织推进，在落叶与铁轨之间，揭开一段漫长而沉重的往事。全剧以电影级质感呈现，被观众誉为"年度最佳国产悬疑神作"。',
  },
  {
    id: 3,
    name: '黑暗荣耀',
    rating: 9.1,
    region: '韩国',
    year: 2025,
    genre: '悬疑',
    episodes: 16,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20Korean%20revenge%20thriller%20drama%20poster%20with%20woman%20in%20dark%20elegant%20clothing%20standing%20by%20a%20large%20window%20overlooking%20a%20city%20at%20twilight%2C%20cold%20blue%20and%20warm%20interior%20light%20contrast%2C%20minimalist%20modern%20design%2C%20intense%20atmosphere&width=480&height=640&seq=drama-poster-03&orientation=portrait',
    description: '高中时期遭受校园暴力的文东恩，在长达十八年的蛰伏后，向曾经的施暴者和旁观者展开精密布局的复仇。宋慧乔主演，以冷峻克制的叙事风格探讨复仇的代价与正义的边界。每一季都保持高水准制作，反转与情绪张力令人窒息。',
  },
  {
    id: 4,
    name: '玉骨遥',
    rating: 8.2,
    region: '国产',
    year: 2026,
    genre: '古装',
    episodes: 40,
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20Chinese%20xianxia%20drama%20poster%20with%20ethereal%20floating%20mountains%20and%20waterfalls%2C%20a%20mysterious%20figure%20in%20flowing%20white%20robes%2C%20soft%20moonlight%20glow%2C%20magical%20atmosphere%2C%20cool%20blue%20and%20silver%20tones%2C%20cinematic%20portrait%20composition&width=480&height=640&seq=drama-poster-04&orientation=portrait',
    description: '孤高清冷的空桑世子时影与热情仗义的赤族郡主朱颜，因一花之恩结下命劫夙缘，却阴错阳差结为师徒相伴三年。命运弄人，归邪升起，空桑将亡，时影误以为陪伴朱颜长大的鲛人止渊就是海皇，于是亲手封印了止渊，而朱颜最终将玉骨刺向了时影。',
  },
  {
    id: 5,
    name: '龙之家族',
    rating: 8.9,
    region: '美国',
    year: 2025,
    genre: '战争',
    episodes: 10,
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20dragon%20drama%20poster%20with%20a%20majestic%20red%20dragon%20flying%20over%20medieval%20castle%20spires%2C%20dramatic%20stormy%20sky%20with%20lightning%2C%20dark%20and%20warm%20color%20palette%2C%20cinematic%20poster%20style%2C%20grand%20epic%20scale%20composition&width=480&height=640&seq=drama-poster-05&orientation=portrait',
    description: '《权力的游戏》前传，讲述坦格利安家族两百年前的那段腥风血雨——血龙狂舞内战。龙之家族继承人之争，维斯特洛大陆上最强大的家族如何从鼎盛走向分裂与毁灭。宏大的战争场面、震撼的巨龙特效与复杂的人物关系，构建了一部史诗级奇幻巨制。',
  },
  {
    id: 6,
    name: '鬼灭之刃',
    rating: 9.2,
    region: '日本',
    year: 2024,
    genre: '战争',
    episodes: 26,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20drama%20poster%20with%20dynamic%20action%20scene%2C%20colorful%20energy%20waves%20in%20warm%20orange%20and%20red%20tones%2C%20dramatic%20combat%20pose%2C%20cinematic%20lighting%2C%20high%20contrast%20design%2C%20bold%20and%20intense%20atmosphere&width=480&height=640&seq=drama-poster-06&orientation=portrait',
    description: '少年炭治郎一家惨遭恶鬼屠杀，唯一幸存的妹妹祢豆子却变成了鬼。为了将妹妹变回人类，并为家人报仇，炭治郎踏上了成为"鬼杀队"剑士的道路。华丽流畅的战斗场面、温暖动人的兄妹羁绊、每一个角色都有令人动容的故事，堪称近年日本动漫的现象级作品。',
  },
  {
    id: 7,
    name: '狂飙',
    rating: 9.0,
    region: '国产',
    year: 2024,
    genre: '悬疑',
    episodes: 39,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anti-corruption%20crime%20drama%20poster%20with%20tense%20confrontation%20scene%2C%20police%20car%20headlights%20at%20night%2C%20dramatic%20red%20and%20blue%20lighting%2C%20urban%20cityscape%20background%2C%20gripping%20atmosphere%2C%20cinematic%20poster%20design&width=480&height=640&seq=drama-poster-07&orientation=portrait',
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子，粉碎了黑恶势力的保护伞，一举铲除了盘踞京海多年的强盛集团。',
  },
  {
    id: 8,
    name: '财阀家的小儿子',
    rating: 8.7,
    region: '韩国',
    year: 2024,
    genre: '都市',
    episodes: 16,
    image: 'https://readdy.ai/api/search-image?query=Korean%20corporate%20drama%20poster%20with%20modern%20skyscraper%20corporate%20office%20setting%2C%20suited%20businessman%20in%20luxurious%20lobby%2C%20warm%20golden%20lighting%2C%20prestigious%20atmosphere%2C%20clean%20minimalist%20design%2C%20high-end%20aesthetic&width=480&height=640&seq=drama-poster-08&orientation=portrait',
    description: '顺洋集团未来资产管理组长尹炫优，因被冤枉涉嫌侵吞资金而遇害，重生为顺洋集团最小的孙子陈导俊。他带着前世的记忆，利用预知未来的优势，在财阀家族的权力斗争中步步为营，试图找出杀害自己的真凶，并登上财阀世界的顶峰。宋仲基一人分饰两角，演技炸裂。',
  },
  {
    id: 9,
    name: '长相思',
    rating: 7.9,
    region: '国产',
    year: 2026,
    genre: '爱情',
    episodes: 39,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20fantasy%20drama%20poster%20with%20beautiful%20woman%20in%20flowing%20traditional%20dress%20among%20blooming%20peach%20blossoms%2C%20soft%20golden%20sunlight%2C%20dreamy%20atmosphere%2C%20pastel%20pink%20and%20warm%20color%20palette%2C%20elegant%20portrait%20composition&width=480&height=640&seq=drama-poster-09&orientation=portrait',
    description: '上古时期，人、神、妖混居，神农、轩辕、高辛三国鼎立。小夭（玖瑶）历经百年颠沛之苦，不但失去了身份，也失去了容貌，成为了"无处可去、无人可依、无力自保"的玟小六。她与表哥轩辕颛顼、九头妖相柳、青丘公子涂山璟之间展开了一段纠葛百年的爱恨情仇。',
  },
  {
    id: 10,
    name: '非常律师禹英禑',
    rating: 8.8,
    region: '韩国',
    year: 2023,
    genre: '都市',
    episodes: 16,
    image: 'https://readdy.ai/api/search-image?query=Korean%20legal%20drama%20poster%20with%20young%20woman%20in%20formal%20attorney%20suit%20standing%20in%20courtroom%2C%20dramatic%20court%20lighting%2C%20determined%20expression%2C%20warm%20wooden%20interiors%2C%20cinematic%20portrait%20composition%2C%20professional%20atmosphere&width=480&height=640&seq=drama-poster-10&orientation=portrait',
    description: '拥有天才头脑和自闭症谱系障碍的禹英禑，作为顶级律所的新人律师，在法律世界中勇敢前行。她用自己的独特视角处理各种棘手案件，在同事和上司的帮助下逐渐成长。温暖治愈的基调，每一集都有令人会心一笑的可爱细节，是近年来最温暖的韩剧之一。',
  },
  {
    id: 11,
    name: '三体',
    rating: 8.6,
    region: '国产',
    year: 2024,
    genre: '科幻',
    episodes: 30,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20with%20futuristic%20space%20scene%20showing%20three%20celestial%20bodies%20orbiting%20each%20other%2C%20cosmic%20nebula%20background%20in%20deep%20purple%20and%20warm%20orange%20tones%2C%20awe-inspiring%20scale%2C%20cinematic%20sci-fi%20aesthetic%2C%20epic%20atmosphere&width=480&height=640&seq=drama-poster-11&orientation=portrait',
    description: '2007年，地球基础科学出现了异常的扰动，纳米科学家汪淼和刑警史强联手调查，发现这一切都与一个名为"科学边界"的组织有关。随着调查的深入，两人逐渐揭开了地外未知文明"三体"世界的神秘面纱，人类的命运面临前所未有的危机。根据刘慈欣同名小说改编。',
  },
  {
    id: 12,
    name: '怪奇物语',
    rating: 9.3,
    region: '美国',
    year: 2025,
    genre: '科幻',
    episodes: 8,
    image: 'https://readdy.ai/api/search-image?query=American%20supernatural%20sci-fi%20drama%20poster%20with%2080s%20retro%20suburban%20neighborhood%20at%20night%2C%20mysterious%20glowing%20portal%20in%20the%20woods%2C%20kids%20on%20bicycles%2C%20dramatic%20red%20and%20blue%20lighting%2C%20nostalgic%20and%20eerie%20atmosphere%2C%20cinematic%20composition&width=480&height=640&seq=drama-poster-12&orientation=portrait',
    description: '1980年代印第安纳州霍金斯小镇，一个小男孩神秘失踪，他的朋友、家人以及当地警察开始寻找答案，随着拥有超能力的女孩出现，一个关于秘密实验和超自然力量的神秘事件逐渐浮出水面。复古80年代氛围，怀旧致敬与原创惊悚完美融合，Netflix口碑最高的原创剧集之一。',
  },
  {
    id: 13,
    name: '以爱为营',
    rating: 7.2,
    region: '国产',
    year: 2026,
    genre: '爱情',
    episodes: 36,
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20romantic%20drama%20poster%20with%20young%20couple%20in%20trendy%20urban%20cafe%20setting%2C%20warm%20afternoon%20sunlight%2C%20coffee%20cups%20and%20flowers%20on%20table%2C%20soft%20bokeh%20background%2C%20sweet%20and%20warm%20atmosphere%2C%20pastel%20color%20palette&width=480&height=640&seq=drama-poster-13&orientation=portrait',
    description: '事业得意的财经记者郑书意为拿下头版，几经努力争取到铭豫云创总裁时宴的专访，两人互相留下深刻印象。在采访和报道的过程中，两人从相识到相知，从互相试探到坦诚相待，展开了一段甜蜜又励志的职场爱情故事。',
  },
  {
    id: 14,
    name: '继承之战',
    rating: 9.5,
    region: '美国',
    year: 2023,
    genre: '都市',
    episodes: 10,
    image: 'https://readdy.ai/api/search-image?query=American%20power%20dynasty%20drama%20poster%20with%20family%20members%20in%20expensive%20suits%20at%20luxury%20skyscraper%20boardroom%2C%20dramatic%20backlighting%2C%20New%20York%20skyline%20at%20sunset%20visible%20through%20floor%20to%20ceiling%20windows%2C%20sophisticated%20and%20tense%20atmosphere&width=480&height=640&seq=drama-poster-14&orientation=portrait',
    description: 'Logan Roy及他的四个孩子控制着全球最大的媒乐媒体集团之一，年迈的Logan开始思考退休后的接班人问题。一场关于权力、金钱与亲情的继承之战在家族内部悄然打响。锋利如刀的台词、黑色幽默的基调、令人窒息的家庭权力博弈，被誉为当代莎士比亚戏剧。',
  },
  {
    id: 15,
    name: '咒术回战',
    rating: 8.4,
    region: '日本',
    year: 2024,
    genre: '战争',
    episodes: 24,
    image: 'https://readdy.ai/api/search-image?query=Dark%20supernatural%20anime%20drama%20poster%20with%20mysterious%20cursed%20energy%20swirling%20around%20a%20young%20protagonist%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20intense%20battle-ready%20stance%2C%20cinematic%20lighting%2C%20bold%20graphic%20design%20style&width=480&height=640&seq=drama-poster-15&orientation=portrait',
    description: '虎杖悠仁是一位体育万能的高中生，某天在学校发现了被封印的诅咒之物，为了拯救同学，他吞下了诅咒的手指，成为了诅咒的容器。随后被东京都立咒术高等专门学校录取，与伏黑惠、钉崎野蔷薇等人一起成为咒术师，对抗危害人间的诅咒。热血战斗与深刻人性探讨并存。',
  },
  {
    id: 16,
    name: '去有风的地方',
    rating: 8.1,
    region: '国产',
    year: 2024,
    genre: '都市',
    episodes: 40,
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20countryside%20drama%20poster%20with%20beautiful%20small%20town%20in%20Yunnan%20mountains%2C%20woman%20walking%20on%20cobblestone%20street%20with%20wind%20bells%20hanging%2C%20warm%20golden%20hour%20light%2C%20serene%20and%20healing%20atmosphere%2C%20lush%20greenery%2C%20soft%20color%20palette&width=480&height=640&seq=drama-poster-16&orientation=portrait',
    description: '许红豆因为闺蜜去世，生活和工作陷入低谷，她独自前往云南大理的云苗村休息调整。在那里，她结识了辞去高薪工作回乡创业的谢之遥，以及其他从大城市来到这里的同龄人。在田园风光和慢节奏生活中，她逐渐找回了内心的平静，也收获了爱情与友情。',
  },
];

export const regions = ['全部', '国产', '韩国', '美国', '日本', '泰国', '英剧'];
export const genres = ['全部', '悬疑', '古装', '都市', '爱情', '战争', '科幻'];
export const years = ['全部', '2026', '2025', '2024', '2023', '2022', '经典'];
export const ratings = ['全部', '9分以上', '8-9分', '7-8分', '6-7分'];

export function getDramaById(id: number): Drama | undefined {
  return dramas.find((d) => d.id === id);
}

export function getSimilarDramas(currentId: number, limit = 4): Drama[] {
  const current = dramas.find((d) => d.id === currentId);
  if (!current) return dramas.slice(0, limit);
  const others = dramas.filter((d) => d.id !== currentId);
  const sameGenre = others.filter((d) => d.genre === current.genre);
  const sameRegion = others.filter((d) => d.region === current.region && d.genre !== current.genre);
  const rest = others.filter((d) => d.genre !== current.genre && d.region !== current.region);
  return [...sameGenre, ...sameRegion, ...rest].slice(0, limit);
}

export const screenshotImages = [
  'https://readdy.ai/api/search-image?query=Cinematic%20TV%20drama%20screenshot%20scene%20with%20dramatic%20character%20close-up%20dialogue%20moment%2C%20soft%20warm%20lighting%2C%20intense%20emotional%20expression%2C%20film%20grain%20texture%2C%20widescreen%20aspect%20ratio%2C%20professional%20color%20grading%2C%20shallow%20depth%20of%20field&width=960&height=540&seq=screenshot-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20TV%20drama%20wide%20shot%20scene%20showing%20grand%20landscape%20or%20interior%20setting%2C%20multiple%20characters%20in%20frame%2C%20atmospheric%20lighting%2C%20film%20grain%20texture%2C%20widescreen%20composition%2C%20professional%20cinematography&width=960&height=540&seq=screenshot-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20TV%20drama%20action%20scene%20with%20dynamic%20movement%2C%20dramatic%20lighting%20and%20shadows%2C%20tense%20atmosphere%2C%20film%20grain%20texture%2C%20widescreen%20aspect%20ratio%2C%20professional%20color%20grading%2C%20high%20contrast&width=960&height=540&seq=screenshot-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20TV%20drama%20romantic%20scene%20with%20two%20characters%20facing%20each%20other%20in%20soft%20golden%20hour%20light%2C%20emotional%20intimate%20moment%2C%20film%20grain%20texture%2C%20widescreen%20aspect%20ratio%2C%20professional%20color%20grading&width=960&height=540&seq=screenshot-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20TV%20drama%20suspense%20scene%20with%20dark%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20single%20character%20in%20contemplation%2C%20film%20grain%20texture%2C%20widescreen%20aspect%20ratio%2C%20professional%20color%20grading&width=960&height=540&seq=screenshot-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20TV%20drama%20establishing%20shot%20of%20beautiful%20location%20with%20stunning%20architecture%20or%20natural%20landscape%2C%20dramatic%20sky%20and%20lighting%2C%20film%20grain%20texture%2C%20widescreen%20aspect%20ratio%2C%20professional%20cinematography&width=960&height=540&seq=screenshot-06&orientation=landscape',
];